import loadable from '@loadable/component';
import './Passengers.css';

export default loadable(() => {
  return import('./Passengers.jsx');
});
